"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transfers = void 0;
const Transfer_1 = require("../types/Transfer");
const ApiResponse_1 = require("../types/ApiResponse");
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../utils");
/**
 * Endpoint to request and filter transfers.
 *
 * @example
 *
 * `transfers(["bitfinexdep1"], {direction: "incoming", quantity_min: 10000})`
 */
function transfers(accounts, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const queryParams = { accounts };
        const yesterday = new Date(Date.now());
        yesterday.setMonth(yesterday.getMonth() - 3);
        // default params
        queryParams.symbol = options.symbol || "EOS";
        queryParams.chain = options.chain || "eos";
        queryParams.direction = options.direction || "both";
        queryParams.accumulated =
            options.accumulated === undefined ? true : options.accumulated;
        queryParams.excludes = options.excludes || [];
        queryParams.quantity_min =
            options.quantity_min === undefined
                ? 1000
                : utils_1.convertQuantity(options.quantity_min, options.chain, true);
        queryParams.time_min =
            options.time_min === undefined
                ? yesterday.toISOString()
                : options.time_min.toISOString();
        queryParams.offset = options.offset || 0;
        queryParams.limit = options.limit || 1000;
        // optional params
        if (options.quantity_max) {
            queryParams.quantity_max = utils_1.convertQuantity(options.quantity_max, options.chain, true);
        }
        if (options.time_max) {
            queryParams.time_max = options.time_max.toISOString();
        }
        if (options.accumulated_min) {
            queryParams.accumulated_min = utils_1.convertQuantity(options.accumulated_min, options.chain, true);
        }
        if (options.accumulated_max) {
            queryParams.accumulated_max = utils_1.convertQuantity(options.accumulated_max, options.chain, true);
        }
        if (options.count_min) {
            queryParams.count_min = options.count_min;
        }
        if (options.count_max) {
            queryParams.count_max = options.count_max;
        }
        try {
            const res = yield axios_1.default.request({
                url: "/transfers",
                params: queryParams,
                transformResponse: (data) => {
                    const json = JSON.parse(data);
                    if (json.error) {
                        return new ApiResponse_1.ApiResponse(undefined, {
                            code: json.code,
                            errorMessage: json.errorMessage,
                        });
                    }
                    const transfersData = json.data.map((value) => {
                        value.chain = options.chain;
                        return Transfer_1.Transfer.fromJson(value);
                    });
                    const accountsData = [];
                    transfersData.forEach((transfer) => {
                        if (!accountsData.some((account) => account.name === transfer.to.name)) {
                            accountsData.push(transfer.to);
                        }
                        if (!accountsData.some((account) => account.name === transfer.from.name)) {
                            accountsData.push(transfer.from);
                        }
                    });
                    return new ApiResponse_1.ApiResponse({
                        accounts: accountsData,
                        transfers: transfersData,
                        limited: json.limited,
                    });
                },
            });
            return yield res.data;
        }
        catch (err) {
            throw err.response.data;
        }
    });
}
exports.transfers = transfers;
//# sourceMappingURL=transfers.js.map